<template>
  <ul
    v-if="$store.state.config.pdd_activity"
    class="CNl7QD1FpnStvA1noMH8"
    :style="deviceInfo.mobile ? 'position:fixed;' : ''"
    :class="
      $store.state.config.ui_version == '3.1' ||
      $store.state.config.ui_version == '3.8'
        ? 'CNl7QD1FpnStvA1noMH8Sandian1'
        : ''
    "
  >
    <li v-if="isShowWheelSpinEvent" class="sidebars-List">
      <img
        style="cursor: pointer"
        src="../../assets/icons/images/temu_icon.webp"
        class="im"
        alt=""
        @click="$store.state.isShowWheelSpinEvent = true"
      />
      <p class="KXUP_IukrjksI9v7ohfA" @click="isShowWheelSpinEvent = false">
        <img
          v-if="$store.state.config.ui_version == '3.1'"
          style="width: 0.3rem; margin-top: 0.1rem"
          v-lazy="fanhuisems"
          alt=""
        />
        <svg-icon
          v-else
          className="svg"
          icon-class="comm_icon_x--svgSprite:all"
        />
      </p>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
      fanhuisems: require('./../../assets/a83cu-6jp7l.png'),
      isShowWheelSpinEvent: true,
      deviceInfo: {}
    };
  },
  created() {
    this.deviceInfo = this.getDeviceInfo();
  },
  mounted() {},
  methods: {
    getDeviceInfo() {
      let u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, //是否微信
        qq: u.match(/\sQQ/i) == ' qq' //是否QQ
      };
    }
  }
};
</script>

<style scoped>
.CNl7QD1FpnStvA1noMH8Sandian1 .sidebars-List,
.CNl7QD1FpnStvA1noMH8Sandian1 .sidebars-List .im {
  width: 1.0884rem !important;
  height: 1.0884rem !important;
}
.CNl7QD1FpnStvA1noMH8Sandian1 .LgFw5l227MkKBKpLD64g {
  margin-left: 0.1rem;
  opacity: 0.9;
}

.csapp37 .LgFw5l227MkKBKpLD64g {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
}
.csapp37 .LgFw5l227MkKBKpLD64g {
  width: 0.9rem;
  height: 0.84rem;
  max-height: 0.84rem;
  min-height: auto !important;
  box-sizing: border-box;
  max-width: 0.9rem;
}
.csapp37 .oBV4WKCvUQyDmGdMy1nT {
  color: var(--skin__text_primary) !important;
}
.LgFw5l227MkKBKpLD64g {
  background-color: var(--theme-main-bg-color);
  border: 0.01rem solid var(--theme-color-line);
  background-size: 100% 100%;
  border-radius: 0.1rem;
  -webkit-box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0.02rem 0 0.06rem 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  -ms-flex-direction: column;
  flex-direction: column;
  min-height: 0.78rem;
  padding: 0.1rem;
  width: 0.84rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.LgFw5l227MkKBKpLD64g {
  min-height: 1rem;
  padding: 0.14rem 0.1rem;
  box-sizing: border-box;
  width: 1.1rem;
  margin-left: 0.5rem;
}

.GO6MyZdeydW4ZcSgnvkK {
  height: 0.38rem;
  width: 0.38rem;
  margin: 0 auto;
}
.GO6MyZdeydW4ZcSgnvkK {
  background-color: var(--theme-primary-color);
  border-radius: 50%;
  color: var(--theme-primary-font-color);
  font-size: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.08rem;
}
.oBV4WKCvUQyDmGdMy1nT {
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  font-size: 0.2rem;
  -webkit-box-orient: vertical;
  color: var(--theme-text-color-lighten);
  display: -webkit-box;
  font-size: 0.18rem;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  vertical-align: middle;
  width: 100%;
}
.GO6MyZdeydW4ZcSgnvkK svg {
  width: 0.2rem;
  height: 0.2rem;
}
.CNl7QD1FpnStvA1noMH8 {
  position: absolute;
  bottom: 1.31rem;
  z-index: 99;
  left: 0.1rem;
}

.CNl7QD1FpnStvA1noMH8 .sidebars-List {
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  margin-top: 0.2rem;
}

.CNl7QD1FpnStvA1noMH8 .sidebars-List .im {
  width: 1.5rem;
  height: 1.5rem;
}

.KXUP_IukrjksI9v7ohfA {
  -ms-flex-align: center;
  -ms-flex-pack: center;
  align-items: center;
  border: 0.01rem solid var(--theme-text-color-lighten);
  border-radius: 50%;
  display: -ms-flexbox;
  display: flex;
  height: 0.2rem;
  justify-content: center;
  position: absolute;
  right: 0;
  z-index: 9999;
  top: 0;
  width: 0.2rem;
}

.KXUP_IukrjksI9v7ohfA .svg {
  color: var(--theme-text-color-lighten);
  height: 0.08rem;
  width: 0.08rem;
}
.menmes3_7 {
  display: none;
}
.csapp37 .menmes {
  display: none;
}
.csapp37 .menmes3_7 {
  display: block;
}
</style>
